import simpleRestProvider from 'ra-data-simple-rest';
import { fetchUtils } from 'react-admin';

export const backendBase = process.env.REACT_APP_BACKEND_BASE ?? 'http://127.0.0.1:8000';
export const adminBase = `${backendBase}/api/admin`;
export const publicBase = `${backendBase}/api`;
// Only these resources are currently namespaced under /api/admin on the backend
const ADMIN_NAMESPACED_RESOURCES = new Set(['prompt_templates', 'dashboard_stats', 'course_material_content']);

// Custom httpClient to attach RBAC user context and auth token
export const httpClient = (url, options = {}) => {
    const opts = { ...options };
    opts.headers = new Headers(opts.headers || {});

    // Determine if this resource should use /api/admin or /api
    // Extract resource name from URL (skip /admin/ if present)
    let finalUrl = url;
    const apiMatch = url.match(/\/api\/(?:admin\/)?([^/?]+)/);
    if (apiMatch) {
        const resource = apiMatch[1];

        if (ADMIN_NAMESPACED_RESOURCES.has(resource)) {
            // This resource should be under /api/admin
            if (!url.includes('/api/admin/')) {
                finalUrl = url.replace('/api/', '/api/admin/');
            }
        } else {
            // This resource should be under /api (not /api/admin)
            if (url.includes('/api/admin/')) {
                finalUrl = url.replace('/api/admin/', '/api/');
            }
        }
    }

    // Provide user context for RBAC on backend
    const userId = localStorage.getItem('userId');
    if (!userId) {
        throw new Error('User not authenticated - no user ID available');
    }
    opts.headers.set('X-User-Id', userId);
    // Include token if available for future backend checks
    const token = localStorage.getItem('token');
    if (token) {
        opts.headers.set('Authorization', `Bearer ${token}`);
    }
    return fetchUtils.fetchJson(finalUrl, opts);
};

// Use publicBase as the default, and let httpClient rewrite to adminBase for namespaced resources
const dataProvider = simpleRestProvider(publicBase, httpClient);

export default dataProvider;
